import { MaterialReactTable } from "material-react-table";
import { useDsvTable } from "@sdk-react-ui-atoms/table";
import {
  TableContainer,
  ToolbarInternalButtons,
} from "@sdk-react-ui-atoms/table/components";
import {
  useTableViews,
  ViewToolbar,
} from "@sdk-react-ui-atoms/table/addons/views";
import TableColumns from "@feature/helpers/TableColumns";

import { useEffect, useState } from "react";
import { ENV } from "@app/constants/env";

const TableViewsToolbar = ({ table, tableId }) => {
  const {
    allViews,
    currentViewId,
    applyView,
    saveNewView,
    deleteView,
    updateViewMeta,
    updateCurrentView,
    isDirty,
  } = useTableViews(table, tableId);

  return (
    <>
      <ViewToolbar
        allViews={allViews}
        currentViewId={currentViewId}
        applyView={applyView}
        saveNewView={saveNewView}
        updateCurrentView={updateCurrentView}
        deleteView={deleteView}
        updateViewMeta={updateViewMeta}
        isDirty={isDirty}
      />
      <ToolbarInternalButtons table={table} />
    </>
  );
};

const Jobs = () => {
  const [shows, setShows] = useState<any[]>([]);
  useEffect(() => {
    const userId = localStorage.getItem("userid")
    ? parseInt(localStorage.getItem("userid")!)
    : 0;
    fetch(`${ENV.SHOW_APIURL}/Shows/GetAllShowForDashboardList/${userId}`)
      .then((response) => response.json())
      .then(setShows);
  }, []);
  const tableId = "shows";

  const table = useDsvTable({
    data: shows,
    columns: TableColumns,
    enablePagination: true,

    renderToolbarInternalActions: ({ table }) => (
      <TableViewsToolbar table={table} tableId={tableId} />
    ),
  });

  return (
    <TableContainer py={4}>
      <MaterialReactTable table={table} />
    </TableContainer>
  );
};
export default Jobs;
